import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from "recharts";

import ChartWrapper from "@/components/common/ChartWrapper";

import { useTheme } from "next-themes";
import { valueLabel } from "@/lib/constants";
import { useGetAverageValuesQuery } from "@/hooks/queries";
const chartConfig: ChartConfig = {
  value: {
    label: "Average Rating",
    color: "#1A5BFA",
  },
};
export default function OccasionChart({
  jobId,
  date,
  valueType,
}: {
  jobId: string;
  date: string;
  valueType: "mrp" | "asp" | "discount";
}) {
  const { data: averageRatingsData, isLoading: averageRatingsDataLoading } =
    useGetAverageValuesQuery({
      jobId: jobId,
      date: date,
    });

  const { theme } = useTheme();

  const chartData = averageRatingsData
    ? Object.entries(averageRatingsData.occasion).map(([occasion, value]) => ({
        occasion,
        value: Number(value[valueType].toFixed(2)),
      }))
    : [];

  return (
    <ChartWrapper
      title="Occasion"
      isLoading={averageRatingsDataLoading}
      className="flex-1"
      hasInfoIcon
      infoText={`The average ${valueLabel} of insights for a given occasion.`}
    >
      <ChartContainer
        config={chartConfig}
        className="aspect-auto h-[250px] w-full"
      >
        <BarChart data={chartData}>
          <XAxis
            dataKey="occasion"
            tickLine={false}
            axisLine={false}
            tickMargin={8}
            stroke={"#E0E0E0"}
          />
          <YAxis
            tickLine={true}
            axisLine={true}
            domain={[0, "dataMax"]}
            tickFormatter={(value) => value.toFixed(2)}
            interval={"preserveEnd"}
            stroke={"#E0E0E0"}
          />
          <CartesianGrid
            vertical={false}
            strokeDasharray={4}
            stroke={"#E0E0E0"}
            opacity={theme === "dark" ? 0.2 : 1}
          />
          <ChartTooltip
            content={
              <ChartTooltipContent
                className="w-[150px]"
                formatter={(value) => (
                  <div className="flex w-full items-center justify-between text-xs text-muted-foreground">
                    <span>{valueType}</span>
                    <span>{value}</span>
                  </div>
                )}
                hideIndicator
              />
            }
          />
          <Bar
            dataKey="value"
            fill={chartConfig.value.color}
            radius={[0, 0, 0, 0]}
            isAnimationActive={false}
          />
        </BarChart>
      </ChartContainer>
    </ChartWrapper>
  );
}
